import {
  gspx,
  GPX_EVENT_TYPES,
  GPX_FEATURES,
  GPX_CAPABILITIES,
  GPX_ROUTES,
} from '@rsos/gainsight';

const LEGACY_CATEGORY = 'Ellington';

const EAGLE_EYE_EVENT_NAMES = {
  CAMERA_EVENT: 'media_eagle_eye_camera_event',
};

const trackCameraEvent = (legacyName, cameraID) => {
  gspx.trackEvent({
    name: EAGLE_EYE_EVENT_NAMES.CAMERA_EVENT,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.MEDIA,
    additionalKeys: {
      legacy_category: LEGACY_CATEGORY,
      legacy_name: legacyName,
      Category: 'Ellington',
      'Launched date': new Date(),
      cameraID,
    },
  });
};

export const trackBlurPreview = (isBlurred, cameraID) => {
  const intentOfClick = isBlurred ? 'unblur' : 'blur';

  trackCameraEvent(`Click to ${intentOfClick} stream`, cameraID);
};

export const trackFetchEagleEyeCookie = (isSuccess, cameraID) => {
  const gainsightText = isSuccess ? 'succeeded' : 'failed';

  trackCameraEvent(`Fetch EEN session cookie ${gainsightText}`, cameraID);
};

export const trackFetchEagleEyePreview = (isSuccess, cameraID) => {
  const gainsightText = isSuccess ? 'succeeded' : 'failed';

  trackCameraEvent(`Fetch preview image ${gainsightText}`, cameraID);
};

export const trackVideoPlay = cameraID => {
  trackCameraEvent('Play Eagle Eye Media', cameraID);
};

export const trackVideoPause = cameraID => {
  trackCameraEvent('Pause Eagle Eye Media', cameraID);
};

export const trackVideoLoadedData = cameraID => {
  trackCameraEvent('Loaded Eagle Eye Media Data', cameraID);
};

export const trackVideoLoadStart = cameraID => {
  trackCameraEvent('Load Eagle Eye Media Start', cameraID);
};

export const trackFullscreen = cameraID => {
  trackCameraEvent('Fullscreen Eagle Eye Media', cameraID);
};
